import { render, staticRenderFns } from "./SocietyContractsCardsTable.vue?vue&type=template&id=510f3f10&scoped=true"
import script from "./SocietyContractsCardsTable.vue?vue&type=script&lang=js"
export * from "./SocietyContractsCardsTable.vue?vue&type=script&lang=js"
import style0 from "./SocietyContractsCardsTable.vue?vue&type=style&index=0&id=510f3f10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510f3f10",
  null
  
)

export default component.exports